<template>
    <div :id="modalId" uk-modal class="employee-craft-form">
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title uk-margin-medium-bottom">Update Craft</h2>
            <div class="uk-grid">
                <div class="uk-form-controls uk-width-2-3">
                    <label for="employee-craft-modal-crafts" class="uk-form-label">Craft</label>
                    <select id="employee-craft-modal-crafts" class="uk-select " v-model="craftId">
                        <option v-for="val in craftOptions" :value="val.id" >{{val.name}}</option>
                    </select>
                </div>
                <div class="uk-form-controls uk-width-1-3">
                    <label for="employee-craft-modal-codes" class="uk-form-label">Default PayCode</label>
                    <select id="employee-craft-modal-codes" class="uk-select " v-model="payCodeId">
                        <option v-for="val in payCodes" :value="val.id" >{{val.code}}</option>
                    </select>
                </div>
            </div>
            <div class="uk-grid uk-margin">
                <div class="uk-form-controls uk-width-2-3">
                    <label for="employee-craft-modal-delegations" class="uk-form-label">Delegation</label>
                    <select id="employee-craft-modal-delegations" class="uk-select " v-model="delegation">
                        <option v-for="val in delegations" :value="val.id" >{{val.name}}</option>
                    </select>
                </div>
                <div class="uk-form-controls uk-width-1-3">
                    <label for="employee-craft-modal-years" class="uk-form-label">Years Exp</label>
                    <input id="employee-craft-modal-years" type="number" class="uk-input" v-model="yearsExperience" />
                </div>
            </div>
            <div class="uk-margin-medium-bottom"></div>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Finish</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>

<script>
    import EventBus from "../../events";
    export default {
        name: "EmployeeCraftForm",

        props:{
            uid:Number,
            modalId:String,
            tableRef:String
        },

        data(){
            return {
                personSkillId:null,
                craftOptions:[],
                payCodes:[],
                delegations:[
                    {
                        id:"primary",
                        name:"Primary"
                    },
                    {
                        id:"secondary",
                        name:"Secondary"
                    },
                    {
                        id:"additional",
                        name:"Additional"
                    }
                ],
                craftId:0,
                payCodeId:0,
                yearsExperience:0,
                delegation:"primary"
            }
        },

        mounted(){
            this.loadCrafts();
        },
        methods:{
            loadCrafts(){
                axios.get("/api/craft/list/all?sort=name&dir=asc")
                    .then((pack) => this.updateCraftData(pack));
            },
            loadForm(id){
                this.personSkillId = id;
                axios.get("/api/employee/"+this.uid+"/craft/" + id)
                    .then((pack) => this.formLoaded(pack));
            },
            formLoaded(pack){
                let dt = pack.data.data;
                this.craftId = dt.skill_id;
                this.payCodeId = dt.pay_code_id;
                this.yearsExperience = dt.years_exp;
                this.delegation = dt.delegation;
            },
            updateCraftData(pack){
                let dt = pack.data.data;
                this.craftOptions = dt;
            },
            updatePayCodeData(pack){
                let dt = pack.data.data;
                let codeFound = false;
                this.payCodes = dt;
                for(let i = 0; i < this.payCodes.length;++i){
                    if(this.payCodes[i].id == this.payCodeId){
                        codeFound = true;
                        break;
                    }
                }
                if(!codeFound){
                    this.payCodeId = this.payCodes[0].id;
                }
            },
            submitForm(){
                let formData = new FormData();
                formData.append("skill_id", this.craftId);
                formData.append("pay_code_id", this.payCodeId);
                formData.append("years_exp", this.yearsExperience);
                formData.append("delegation", this.delegation);

                axios.post("/api/employee/"+this.uid+"/craft" + (this.personSkillId ? "/"+this.personSkillId:""), formData)
                    .then((pack) => this.dataUpdated(pack));
            },
            dataUpdated(pack){
                this.$root.$refs[this.tableRef].loadCrafts();
                let chosenCraft = null;
                for(let i = 0; i < this.craftOptions.length;++i){
                    if(this.craftOptions[i].id == this.craftId){
                        chosenCraft = this.craftOptions[i];
                    }
                }
                if(pack.data.success){
                    EventBus.fireEvent("message", chosenCraft.name + " added.");
                } else {
                    EventBus.fireEvent("error", chosenCraft.name + " could not be added.");
                }
                this.craftId = 0;
                this.yearsExperience = 0;
                this.delegation = "primary";
            },
            cancel(){
                if(this.personSkillId){
                    this.personSkillId = null;
                    this.craftId = 0;
                    this.payCodeId = 0;
                    this.yearsExperience = 0;
                    this.delegation = "primary";
                }

            }
        },
        watch:{
            craftId(){
                if(this.craftId == 0){
                    this.payCodes = [];
                } else {
                    axios.get("/api/craft/"+this.craftId+"/paycodes/list")
                        .then((pack) => this.updatePayCodeData(pack));
                }
            }
        }
    }
</script>

<style scoped>

</style>
